
            const data = {"name":"glyph/24/ctrl-right","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m8.809 23.588-1.617-1.176L14.764 12 7.191 1.588 8.808.412l8 11a1 1 0 0 1 0 1.176l-7.999 11z\" class=\"nc-icon-wrapper\" _fill=\"#272c33\"/>","originalColors":[{"type":"fill","color":"#272c33"}],"stopColors":[]}}
        
                    module.exports = data
                    